<template>
  <div class="c-app">
    <Sidebar />
    <Dock />
    <CWrapper>
      <Header />
      <div class="c-body">
        <main class="c-main">
          <CContainer fluid>
            <transition name="fade" mode="out-in">
              <router-view :key="$route.path"></router-view>
            </transition>
          </CContainer>
        </main>
      </div>
      <Footer />
      <mediaModal />
    </CWrapper>
  </div>
</template>

<script>
import mediaModal from '@/components/widgets/MediaModal.vue';
import Sidebar from './Sidebar.vue';
import Dock from './Dock.vue';
import Header from './Header.vue';
import Footer from './Footer.vue';

export default {
  name: 'DashboardLayout',
  components: {
    Sidebar,
    Header,
    Footer,
    Dock,
    mediaModal
  },
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
